import { getPosts } from '$lib/content';

export const prerender = true;

export function load() {
	return {
		posts: getPosts()
	};
}
